'use es6';

import { getUtk, UNKNOWN_UTK } from '../util/Cookies';
import { createClient } from 'laboratory-lib';
import { makeLaboratoryHooks } from 'cms-growth-lib/laboratory/factories/makeLaboratoryHooks';
const identifier = getUtk() || UNKNOWN_UTK;
const laboratoryClient = createClient({
  quickFetchLabel: 'experiment-treatments',
  experiments: {},
  identifiers: {
    utk: identifier === UNKNOWN_UTK ? null : identifier
  },
  timeout: 8000
});
const {
  TreatmentContext,
  TreatmentProvider,
  useTreatment
} = makeLaboratoryHooks(laboratoryClient);
export { TreatmentContext, TreatmentProvider, useTreatment };